export const careerUrl = "https://karmalife-talent.freshteam.com/jobs";
export const blogUrl = "https://blog.karmalife.ai/?utm_campaign=KarmaLifeWebsite&utm_medium=websiteheader";
export const blogAdvanceUrl = "https://blog.karmalife.ai/advance-cash/"
export const blogCreditUrl = "https://blog.karmalife.ai/credit-solutions-gig-workers/"
export const earlySalaryUrl = "https://blog.karmalife.ai/early-salary-employees/"
export const earnedWageUrl = "https://blog.karmalife.ai/earned-wage-access/"
export const financialUrl = "https://blog.karmalife.ai/financial-security-workers/"
export const onDemandUrl = "https://blog.karmalife.ai/ondemand-salary-workers/"
export const safeCreditUrl = "https://blog.karmalife.ai/safe-credit-workforce/"
export const inadvanceSalaryUrl = "https://blog.karmalife.ai/salary-inadvance/"
export const downloadApp = "https://play.google.com/store/apps/details?id=in.onionlife.karmalife";
export const fbLink = "https://business.facebook.com/KarmaLifeAI";
export const linkedinLink = "https://www.linkedin.com/company/karmalifeai";
export const twitterLink = "https://twitter.com/Karmalife_AI";
export const contactUsLink = "mailto:contact@karmalife.ai";
export const pageLink = {
    home: '/',
    about: '/about',
    ourSolutions: '/our-solutions',
    media: '/media',
    faq: '/faq',
    privacyPolicy: '/privacy-policy',
    termsCondition: '/terms-and-conditions',
    grevianceRedressalPolicy: '/grievances-redressal-policy',
    codeOfConduct: '/code-of-conduct'

}